import { generateCorrectSlug } from '../helpers/generate-correct-slug';
import { calculatePrefixPath } from '../helpers/rendered-page-creation/calculate-prefixed-path';
import { IMeetingPlaceLinkToAnyPage } from '../queries/fragments/meetingPlaceLinkToAnyPage';

export const useCalculateSlug = (
  slugData: string | IMeetingPlaceLinkToAnyPage,
): string => {
  if (slugData instanceof Object) {
    return generateCorrectSlug(slugData);
  } else if (typeof slugData === 'string') {
    return calculatePrefixPath(slugData);
  } else {
    return '';
  }
};
